import React from 'react'
import PuzzleIcon from '../../../../sharedComponents/src/globalHeader/icons/puzzle'
import PuzzleTitle from '../../components/PuzzleTitle'

const PuzzlePracticeTitle: React.FC = () => {
    return <PuzzleTitle icon={<PuzzleIcon />} title="Puzzle Practice" />
}

export default PuzzlePracticeTitle
